import {
  IconActionHistory,
  IconCatalog,
  IconCheck,
  IconWarning,
} from '@procurify/ui'

import {
  type CatalogItemTagIcon,
  CatalogItemTagIcons,
} from '../../value-objects/CatalogItemTag'

export interface ICatalogItemTagGlyphProps {
  icon: CatalogItemTagIcon
  size: number
}

export const CatalogItemTagGlyph = ({
  icon,
  size,
}: ICatalogItemTagGlyphProps) => {
  switch (icon) {
    case CatalogItemTagIcons.WARNING:
      return <IconWarning size={size} />
    case CatalogItemTagIcons.CATALOG:
      return <IconCatalog size={size} />
    case CatalogItemTagIcons.PREVIOUS_ORDER:
      return <IconActionHistory size={size} />
    case CatalogItemTagIcons.CHECKMARK:
      return <IconCheck size={size} />
    default:
      return null
  }
}
